import type { Vessel } from '../../models/vessels/vessel.model';

export interface MyFleetVessel extends Vessel {
  flag?: string;
  timestamp: string;
}

export function isFleetVessel(
  vessel: Vessel | MyFleetVessel
): vessel is MyFleetVessel {
  return (vessel as MyFleetVessel).vessel_id !== undefined;
}
